var SENTRY_RELEASE;SENTRY_RELEASE={name: "icare", version: "1.0.3"};